<template>
  <div
    style="position: relative"
    class="user-item pa-1"
    :class="{
      'grey lighten-3': selected
    }"
    :style="customBackgroundStyle"
  >
    <v-list-tile avatar class="px-0">
      <v-list-tile-avatar style="position: relative">
        <template v-if="user.profile_pic">
          <img class="profile" :src="user.profile_pic" alt @error="imgError(this)" />
        </template>
        <template v-else>
          <img class="profile" src="/static/img/assets/livechat/profile.png" alt />
        </template>
        <div style="position: absolute; bottom: -8px; right: -2px; z-index: 2">
          <em
            :class="[
              'fas fa-brands',
              { 'fa-facebook': user.app === 'facebook' },
              { 'fa-x': user.app === 'x' },
              { 'fa-pantip': user.app === 'pantip' }
            ]"
            style="width: 16px; height: 16px; background-size: 16px 16px"
          ></em>
        </div>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title
          :class="{
            unreadmessage: !user.is_admin_read
          }"
          :style="{ height: '18px', color: '#2e2e2e' }"
          style="
            font-size: 12px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
          "
          ><span>{{ user.pagename }}</span
          ><span>{{ $t(`all_in_one_chat.${user.platform_type}`) }}</span></v-list-tile-title
        >
        <v-list-tile-title
          :style="{ color: '#2e2e2e' }"
          style="font-size: 14px"
          :class="{ unreadmessage: !user.is_admin_read }"
        >
          {{ `${user.first_name} ${user.last_name}` }}
        </v-list-tile-title>
        <v-list-tile-sub-title
          class="caption"
          :class="{
            unreadmessage: !user.is_admin_read
          }"
          :style="{ height: '18px', color: '#030303' }"
          v-html="sanitize(convertMessage(user.last_message))"
        ></v-list-tile-sub-title>
        <v-list-tile-sub-title :style="{ color: '#484848' }">
          <div style="display: flex; align-items: center; justify-content: space-between">
            <span>
              <v-chip
                v-if="user.tickets && user.tickets[0] && user.tickets[0].assignadminid"
                small
                :color="isBlackShip ? 'black' : 'primary'"
                dark
                outline
                class="caption"
                style="height: 20px; font-size: 12px; margin: 4px 0"
                :class="{
                  unreadmessage: !user.is_admin_read
                }"
              >
                {{ user.tickets[0].assignadminid || '-' }}
              </v-chip>
            </span>
            <span
              class="caption"
              :class="{
                unreadmessage: !user.is_admin_read
              }"
              >{{ dayLeft(user.last_message_timestamp) }}</span
            >
          </div>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import DOMPurify from 'dompurify'

export default {
  filters: {
    time: function (date) {
      if (typeof date === 'string') {
        date = moment(date)
      }
      return date.format('h:mm A')
    },
    fmMessage(value) {
      if (value && value.startsWith('data:image')) {
        return 'image'
      } else {
        return value
      }
    }
  },
  props: ['value', 'selected'],
  data: function () {
    return {
      user: {},
      input: {
        ticket2status: ''
      },
      hasNewMessage: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot', 'livechat']),
    isBlackShip() {
      return (
        !this.user.is_admin_read ||
        (this.user.tickets &&
          this.user.tickets[0] &&
          this.user.tickets[0].is_transfer_ticket === true &&
          !this.user.tickets[0].admin_read_ticket)
      )
    },
    customBackgroundStyle() {
      let bgStyle = ''
      if (!this.user.is_admin_read) {
        bgStyle = { backgroundColor: '#EC9135 !important' }
      }
      if (
        this.user.tickets &&
        this.user.tickets[0] &&
        this.user.tickets[0].is_transfer_ticket === true &&
        !this.user.tickets[0].admin_read_ticket
      ) {
        bgStyle = { backgroundColor: '#FE8C8C !important' }
      }

      return bgStyle
    }
  },

  watch: {
    value: function (newVal, oldVal) {
      this.user = newVal
      if (newVal.last_message_timestamp != oldVal.last_message_timestamp) {
        if (this.selected != true) {
          this.hasNewMessage = true
        }
      }
    }
  },
  async mounted() {
    if (this.value) {
      this.user = this.value
    }
  },

  methods: {
    convertMessage(message) {
      if (message && message.startsWith('data:image')) {
        return 'image'
      }
      if (message && ['&lt;', '&gt;'].some((entity) => message.includes(entity))) {
        return message.replaceAll(/&lt;/g, '<').replaceAll(/&gt;/g, '>')
      }
      return message
    },
    sanitize(dirty) {
      return DOMPurify.sanitize(dirty, { ALLOWED_TAGS: ['a', 'br'], ALLOWED_ATTR: ['href'] })
    },
    imgError: function () {
      this.user.profile_pic = '/static/img/assets/livechat/profile.png'
    },
    dayLeft: function (replytime) {
      let lastreply = moment(replytime)
      let currentDate = moment()

      let time = ''
      if ([...this.$store.state.bbqPage].includes(this.selectedBot.pageid)) {
        time = lastreply.format('DD MMM YYYY HH:mm')
      } else {
        if (currentDate.diff(lastreply, 'days') > 0) {
          time = lastreply.format('DD MMM YYYY')
        } else if (currentDate.diff(lastreply, 'hours') > 0) {
          time = currentDate.diff(lastreply, 'hours')
          time += ' ' + this.$t('Hours')
        } else if (currentDate.diff(lastreply, 'minutes') > 0) {
          time = currentDate.diff(lastreply, 'minutes')
          time += ' ' + this.$t('Minutes')
        } else if (currentDate.diff(lastreply, 'seconds') > 0) {
          time = currentDate.diff(lastreply, 'seconds')
          time += ' ' + this.$t('Seconds')
        }
      }
      return time
    }
  }
}
</script>

<style lang="scss">
.px-0 .v-list__tile {
  padding-left: 5px !important;
  padding-right: 2px !important;
}
.unreadmessage {
  color: black !important;
  font-weight: bold !important;
}
.dark-style {
  .v-list__tile__title {
    color: #000 !important;
  }
}
.v-list__tile--avatar {
  height: 86px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-user-item.vue